import NewUserConnection from './container';

export default NewUserConnection;



// WEBPACK FOOTER //
// ./src/components/NotificationsTypes/NewUserConnection/index.js